import { config } from '@storybook/addon-actions';
import { getApi } from '../services/api/api'

export const fetchConfig = async (baseurl,key) => {
    let url = baseurl+'/api/states/sensor.ee_m_eesystem';
    let configResponse = await getApi(url,key);
    
    if (configResponse.success) {
        return {
            "success": true,
            "availableEnergie": configResponse.data.attributes.availableEnergy,
            "availableSensors": configResponse.data.attributes.potties,
            "powerTypes": configResponse.data.attributes.powerTypes,
            "receivePowerMatrix": configResponse.data.attributes.receivePowerMatrix,
        };
    }else {
        return {
            "success": false,
            "data": null
        };
    }
}

